import MultiForm from '@admin/components/multiform'
import CanvaImport from './canva_import'
import PropTypes from 'prop-types'
import Strategy from './strategy'
import Document from './document'
import Details from './details'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(New Resource)',
      action: '/api/admin/truevail/admin/resources',
      method: 'POST',
      defaultValue: {
        type: 'document'
      },
      getSteps: this._getSteps,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getSteps(formdata) {
    const { type } = formdata
    return [
      { label: 't(Strategy)', component: Strategy },
      ...type === 'document' ? [
        { label: 't(Document)', component: Document }
      ] : type === 'canva' ? [
        { label: 't(Canva)', component: CanvaImport },
        { label: 't(Details)', component: Details }
      ] : []
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(resources) {
    this.context.modal.close()
  }

}

export default New
